import { GET_HISTORY_INDEX_DATA } from "./actionType";

const defaultState = {
  historyData: [],//展示数据

};
const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case GET_HISTORY_INDEX_DATA://存
      return { ...state, ...action };
    default:
      return state;
  }
};

export default Reducer;
